import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface SyncStatusBadgeProps {
  status: boolean;
  importedData: string;
}

export default function SyncStatusBadge({ status, importedData }: SyncStatusBadgeProps) {
  const { t } = useTranslation('periods');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minWidth: 150,
        px: 2,
        py: importedData ? 0.339 : 1.22,
        borderRadius: 0.5,
        borderLeft: 4,
        borderLeftColor: status ? 'success.main' : 'grey.500',
        bgcolor: status ? 'success.light' : 'grey.100',
        color: status ? 'success.dark' : 'grey.700',
      }}
    >
      <Typography component="p" variant="body2">
        {status ? t('Processado') : t('Não Processado')}
      </Typography>
      {status && (
        <Box
          sx={{
            fontSize: 10,
            opacity: 0.7,
          }}
        >
          {importedData}
        </Box>
      )}
    </Box>
  );
}
